
    import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
    import { translate } from "../../services/translation/translation";

    @Component({})

    export default class ColorToneCard extends Vue {
        @Prop() !color_tone;


        isExist(attributes: any) {
            if (
                    typeof attributes == undefined ||
                    attributes == null ||
                    attributes == ""
            ) {
            return false;
            } else {
            return true;
            }
        }

         trans(key) {
            return translate(key);
        }
    }
